export const MAX_TRACKING_FRAMES = 100;
export const SEQUENCE_VALIDATION_ERRORS = {
  SEQUENCE_VALIDATION_ERROR: 'Please select a valid range',
  TRACKING_VALIDATION_ERROR: `You can only track up to ${MAX_TRACKING_FRAMES} frames at a time`
};
export const MIN_VALUE_CAPTION = 'min:';
export const MAX_VALUE_CAPTION = 'max:';
export const SEQUENCE_LABEL_START = 'Start';
export const SEQUENCE_LABEL_END = 'End';
export const SEQUENCE_LABEL_NEXT = 'Next';
export const KEYFRAME_STEPPER_ADJUST_LABEL = 'Adjust the bounding box in the key frames';
export const KEYFRAME_STEPPER_MAX_VISIBLE_CHIPS = 3;
export const SEQUENCE_MODAL_TYPE = ({
  TRACK: 'track',
  INTERPOLATE: 'interpolate'
} as const);